/**
 * Approved icon set (react-icons/md only — emoji are content, never icons).
 *
 * Import icons from here rather than from 'react-icons/md' directly so the whole app
 * shares one vocabulary. Sizes: w-4 h-4 (16) / w-5 h-5 (20) / w-6 h-6 (24); colour via
 * currentColor. Decorative icons get aria-hidden="true".
 *
 *   import { MdBedtime, EVENT_ICON, EVENT_TONE } from '../../shared/icons';
 *   const Icon = EVENT_ICON.SLEEP;  const tone = EVENT_TONE.SLEEP; // 'sleep'
 */
import {
  MdRestaurant,
  MdBedtime,
  MdBabyChangingStation,
  MdToys,
  MdWaterDrop,
  MdThermostat,
  MdStraighten,
  MdStar,
  MdVaccines,
  MdMedication,
  MdNoFood,
  MdFavorite,
  MdBarChart,
  MdShield,
  MdSettings,
  MdHelpOutline,
  MdLightbulb,
  MdWorkspacePremium,
  MdCardGiftcard,
} from 'react-icons/md';

export {
  // Navigation / chrome
  MdHome,
  MdMoreHoriz,
  MdMoreVert,
  MdMenu,
  MdArrowBack,
  MdArrowForward,
  MdChevronLeft,
  MdChevronRight,
  MdExpandMore,
  MdExpandLess,
  MdKeyboardArrowDown,
  MdClose,
  MdSearch,
  MdFilterList,
  MdTune,
  MdOpenInNew,
  MdShare,
  MdDownload,
  MdContentCopy,
  MdLink,
  MdRefresh,
  MdSync,
  MdLogout,
  MdPerson,
  MdPeople,
  MdGroup,
  MdChildCare,
  MdCake,
  // Actions
  MdAdd,
  MdRemove,
  MdEdit,
  MdDelete,
  MdCheck,
  MdCheckCircle,
  MdCheckCircleOutline,
  MdPlayArrow,
  MdPause,
  MdStop,
  MdTimer,
  MdSchedule,
  MdAccessTime,
  MdHistory,
  MdCalendarToday,
  MdCalendarMonth,
  MdEvent,
  MdBookmark,
  MdBookmarkBorder,
  MdFavoriteBorder,
  MdStarBorder,
  MdNotifications,
  MdNotificationsNone,
  MdNotificationsOff,
  MdVisibility,
  MdVisibilityOff,
  MdPhone,
  MdCall,
  MdEmail,
  // Status / feedback
  MdInfoOutline,
  MdInfo,
  MdWarningAmber,
  MdErrorOutline,
  MdError,
  MdCloudOff,
  MdCloudDone,
  MdInbox,
  MdBolt,
  MdAutoAwesome,
  MdInsights,
  MdTrendingUp,
  MdTrendingDown,
  MdTrendingFlat,
  // Theme
  MdWbSunny,
  MdNightlight,
  MdNightsStay,
  MdDarkMode,
  MdLightMode,
  MdBrightnessAuto,
  // Domain
  MdLocalDrink,
  MdOpacity,
  MdCrib,
  MdMenuBook,
  MdSchool,
  MdHealthAndSafety,
  MdLocalHospital,
  MdMedicalServices,
  MdSick,
  MdMood,
  MdSentimentSatisfied,
  MdEmojiEvents,
  MdFlag,
  MdLock,
  MdLockOpen,
} from 'react-icons/md';

export {
  MdRestaurant,
  MdBedtime,
  MdBabyChangingStation,
  MdToys,
  MdWaterDrop,
  MdThermostat,
  MdStraighten,
  MdStar,
  MdVaccines,
  MdMedication,
  MdNoFood,
  MdFavorite,
  MdBarChart,
  MdShield,
  MdSettings,
  MdHelpOutline,
  MdLightbulb,
  MdWorkspacePremium,
  MdCardGiftcard,
};

/** One icon per feature / event type. */
export const EVENT_ICON = {
  FEED: MdRestaurant,
  SLEEP: MdBedtime,
  NAPPY: MdBabyChangingStation,
  ACTIVITY: MdToys,
  PUMPING: MdWaterDrop,
  ILLNESS: MdThermostat,
  GROWTH: MdStraighten,
  MILESTONE: MdStar,
  VACCINATION: MdVaccines,
  MEDICATION: MdMedication,
  ALLERGY: MdNoFood,
  MOOD: MdFavorite,
  REPORTS: MdBarChart,
  SAFETY: MdShield,
  SETTINGS: MdSettings,
  HELP: MdHelpOutline,
  TIPS: MdLightbulb,
  SUBSCRIPTION: MdWorkspacePremium,
  REFER: MdCardGiftcard,
};
// Legacy alias used by the design-system audit.
EVENT_ICON.VACCINE = EVENT_ICON.VACCINATION;

/**
 * Tone name per feature, matching the `tone` prop vocabulary shared by Card, Pill,
 * Banner, IconButton, StatTile, StatusHero, Avatar:
 * neutral | primary | warm | success | warning | danger | feed | sleep | nappy | activity | pump | health
 */
export const EVENT_TONE = {
  FEED: 'feed',
  SLEEP: 'sleep',
  NAPPY: 'nappy',
  ACTIVITY: 'activity',
  PUMPING: 'pump',
  ILLNESS: 'health',
  GROWTH: 'primary',
  MILESTONE: 'warm',
  VACCINATION: 'health',
  MEDICATION: 'health',
  ALLERGY: 'health',
  MOOD: 'health',
  REPORTS: 'primary',
  SAFETY: 'primary',
  SETTINGS: 'neutral',
  HELP: 'neutral',
  TIPS: 'warm',
  SUBSCRIPTION: 'warm',
  REFER: 'success',
};
EVENT_TONE.VACCINE = EVENT_TONE.VACCINATION;
